<template>
    <div class="progress-bar-container">
        <div class="progress-bar"
             :style="{ width: progressDistance + '%' }"
             :class="{ 'threshold-color' : isPastThreshold && changeColorAfterThreshold }">
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {

        },
        data() {
            return {

            }
        },
        computed: {
          progress() {
              return Math.round((this.value / this.max) * 100);
            },
            invertedProgress() {
              if ( this.value > this.max ) {
                  return 100;
              } else {
                  return Math.round(((this.max - this.value) / this.max) * 100);
              }
            },
            progressDistance() {
                if ( this.invert ) {
                    return this.invertedProgress;
                } else {
                    return this.progress;
                }
            },
            isPastThreshold() {
              return this.progress >= this.thresholdComputed;
            },
            thresholdComputed() {
              return this.threshold || 90;
            }
        },
        props: {
            value: {
                type: [Number, String],
                required: true,
                default: 0
            },
            max: {
                type: [Number, String],
                required: true,
                default: 1
            },
            invert: {
                // should progress be shown as a shrinking progress bar instead of
                // a growing one
                type: Boolean,
                required: false,
                default: true
            },
            changeColorAfterThreshold: {
                type: Boolean,
                required: false,
                default: true
            },
            // Percentage to max where the progress bar turns red
            threshold: {
                type: Number,
                required: false,
                default: null
            }
        }
    }
</script>

<style scoped>
    .progress-bar-container {
        @apply bg-gray-100 w-full h-3 flex rounded;
    }

    .progress-bar {
        @apply h-full bg-blue-400 rounded;
    }

    .threshold-color {
        @apply bg-red-500;
    }

</style>
